import PropTypes from "prop-types";
import "./ChartContextMenu.scss";

const getMenuItems = () => [
  {
    key: "fullscreen",
    label: document.fullscreenElement ? "Exit Fullscreen" : "View Fullscreen",
  },
  { key: "separator" },
  { key: "csv", label: "Download CSV" },
  { key: "xls", label: "Download XLS" },
  { key: "png", label: "Download PNG" },
];

const ChartContextMenu = ({ open, onToggle, menuRef, actions }) => {
  const actionMap = {
    fullscreen: actions.handleFullscreen,
    csv: actions.handleDownloadCSV,
    xls: actions.handleDownloadXLS,
    png: actions.handleDownloadPNG,
  };

  const menuItems = open ? getMenuItems() : [];

  return (
    <div ref={menuRef} className="chart-context-menu">
      <button onClick={onToggle} className="chart-context-menu__button" title="Chart menu">
        &#9776;
      </button>
      {open && (
        <div className="chart-context-menu__dropdown">
          {menuItems.map((item, i) =>
            item.key === "separator" ? (
              <div key={`separator-${i}`} className="chart-context-menu__separator" />
            ) : (
              <button key={item.key} onClick={actionMap[item.key]} className="chart-context-menu__item">
                {item.label}
              </button>
            )
          )}
        </div>
      )}
    </div>
  );
};

ChartContextMenu.propTypes = {
  open: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  menuRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({ current: PropTypes.any })]).isRequired,
  actions: PropTypes.shape({
    handleFullscreen: PropTypes.func.isRequired,
    handleDownloadCSV: PropTypes.func.isRequired,
    handleDownloadXLS: PropTypes.func.isRequired,
    handleDownloadPNG: PropTypes.func.isRequired,
  }).isRequired,
};

export default ChartContextMenu;
